import { Component, OnInit } from '@angular/core';
import { CommonService } from './../Services/common.service';
import { DatePipe } from '@angular/common';
import { Subject } from "rxjs";
import { AccountService, cardDetail, loanDetail } from '../Services/account.service';
import { AuthService } from '../Services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { CardServiceService } from '../Services/card-service.service';
import { Base64 } from 'js-base64';
import { CookieService } from '../Services/cookie';

import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-loan-payment-history',
  templateUrl: './loan-payment-history.component.html',
  standalone:false,
  styleUrls: ['./loan-payment-history.component.scss']
})
export class LoanPaymentHistoryComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();

  selectedMonth:string="";
  Monthlist
  loanDetail;
  selectedLoanDetail:loanDetail;
  ViewStatementList;
  MonthYear:string="";
  UnGroupLoanTransactionHistory
  selectedLoanIndex:number
  internalId:string='';
  EmailIds:string='';
  serviceType: any;


  constructor(private route: ActivatedRoute, private toastr: ToastrService, private cookieService: CookieService, private router: Router, private auth:AuthService,public commonP:CommonService,private account:AccountService,private _router:Router) { }

 async ngOnInit(): Promise<void>{ 
    this.serviceType = await this.cookieService.get("sTyp", true);
    console.log("serviceTypeData", this.serviceType);
  //   this.Monthlist = [
  //   {
  //     iconClass:"",
  //     displayValue:"January",
  //   },
  //   {
  //     iconClass:"",
  //     displayValue:"Febuary",
  //   },  {
  //     iconClass:"",
  //     displayValue:"March",
  //   },  {
  //     iconClass:"",
  //     displayValue:"April",
  //   },  {
  //     iconClass:"",
  //     displayValue:"May",
  //   },  {
  //     iconClass:"",
  //     displayValue:"June",
  //   },  {
  //     iconClass:"",
  //     displayValue:"July",
  //   },  {
  //     iconClass:"",
  //     displayValue:"August",
  //   },  {
  //     iconClass:"",
  //     displayValue:"September",
  //   },  {
  //     iconClass:"",
  //     displayValue:"October",
  //   },  {
  //     iconClass:"",
  //     displayValue:"November",
  //   },  {
  //     iconClass:"",
  //     displayValue:"December",
  //   }
  // ]

  this.route.queryParams.subscribe(params => {
    if(params['id']){
      this.internalId=params['id'];
    }
  });
  
    this.auth.accessToken = await this.commonP.Get("token");
    await this.commonP.presentLoading();
    this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
      if (data.response) {
        if (data.response.code) {
          if (data.response.code == 1) {
           
              let body = {
                internalId: this.internalId,
                numberOfTransactions: 10,
                transactionType: "Statement",
                downloadType: "Data",
                email: false,
                emailId: ''
          
              }
          
              this.commonP.presentLoading();
              this.account.GetLoanStatement(body, this.auth.accessToken).then((data: any) => {
                if (data?.response?.code == 1) {
                  console.log("GetLoanStatement",data);
                  this.commonP.hideLoading();
                  this.EmailIds=this.auth?.detailuser?.emailId;
                  this.ViewStatementList = data.response.content.lst
                } else {
                  
                  this.commonP.hideLoading();
                  this.commonP.ParseErrorAlert('', '', this._router, data);
                }
          
          
          
              })
          
          
            
  
          } else {
            await this.commonP.hideLoading();
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        } else {
          await this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      } else {
        await this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "", this._router, data);
      }
    });
  
  
  

  
}

// onMonthChange(event) {
//   this.selectedMonth = event.displayValue;
// }

showModal(num) {
  this.modalObservable.next(num);
}

back() {
  this.router.navigateByUrl("/DashboardLoans");
}


selectedCard: number = 0;
  selectCard(e) {
    this.selectedLoanDetail=this.loanDetail[e];
    this.selectedCard = e;

  }

  DownloadStatement(){
    
    
    let body={
      internalId:this.internalId,
      numberOfTransactions: null,
      // transactionType:"download",
  // downloadType: "pdf",
      transactionType:"STATEMENT",
  downloadType: "base64",
  email: false,  
  emailId:''
    }
  
    this.commonP.presentLoading();
  this.account.GetLoanStatement(body,this.auth.accessToken).then((data:any)=>{
    if(data?.response?.code==1){
      this.commonP.hideLoading();
      // For Download file 
      let decodedData = Base64.decode(data.response.content.base64);
      let blob = new Blob([decodedData], { type: 'application/pdf' });
      saveAs(blob, data.response.content.fileName);
      
      // For Open in new tab
      
      // let fileUrl = URL.createObjectURL(blob);
       // window.open(fileUrl, '_blank');
     
  
  
  
    }else{
      
      this.commonP.hideLoading();
      this.commonP.ParseErrorAlert('', '', this._router, data);
    }
  
  
  
  })
  
   }

   SendStatementToEmail(){

    
    let body={
      internalId:this.internalId,
      numberOfTransactions: null,

  transactionType:"STATEMENT",
  downloadType: "EMAIL",
  email: true,  
  emailId:this.EmailIds
    }
  
    this.commonP.presentLoading();
  this.account.GetLoanStatement(body,this.auth.accessToken).then((data:any)=>{
    if(data?.response?.code==1){
      console.log("GetLoanStatement",data);

      // this.toastr.success(
      //   "You have successfully sent your statement",
      //   "Your Statment has been sent"
      // );
      this.toastr.success('You should receive your statement in your inbox at '+this.EmailIds,'Your statement has been sent'  );
      this.commonP.hideLoading();
   
  
    }else{
      
      this.commonP.hideLoading();
      this.commonP.ParseErrorAlert('', '', this._router, data);
    }
  
  
  
  })
  
   }
}